import React from 'react';

const PdfHeaderComponent = ({ projectTitle = "Water Network Project", organizationName = "Solarpunk Guild" }) => {
  return (
    <div className="flex justify-between items-start mb-6">
      <div className="text-lg text-[#636363] font-medium">{projectTitle}</div>
      <div className="flex items-center">
        <div className="w-5 h-5 bg-green-600 rounded-full mr-2 flex items-center justify-center">
          <span className="text-white text-xs font-bold">S</span>
        </div>
        <span className="text-lg text-[#636363] font-medium">{organizationName}</span>
      </div>
    </div>
  );
};

export default PdfHeaderComponent;
